'use client';

import { create } from 'zustand';

import type { MiniPdpDrawerOptions, MiniPdpDrawerState } from '../types';

export const useMiniPdpDrawer = create<MiniPdpDrawerState>(set => ({
    isOpen: false,
    productId: null,
    source: undefined,
    open: (options?: MiniPdpDrawerOptions) => {
        set({
            isOpen: true,
            productId: options?.productId ?? null,
            source: options?.source,
        });
    },
    close: () => set({ isOpen: false, productId: null, source: undefined }),
}));
